export default __webpack_public_path__ + "static/media/NMAH.AC.0433_ref7143.00e0f3db.jpg";